import type { UserRole } from '@shared/types/user_role';

export const ROLES: Set<UserRole> = new Set<UserRole>((window.clutter.user?.roles as UserRole[]) ?? []);
